// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3ef_p","unreadBadge":"styles_unreadBadge__ODZf4","modalContent":"styles_modalContent__6OidO","modal":"styles_modal__uTyRg"};